import { TechnologyCard } from '../../../../../features/technologies/components/TechnologyCard';
import { useI18n } from '../../../../../shared/i18n';
import { useData } from '../../../../../shared/lib';
import { Container, EmptyState, Eyebrow, Grid, Section } from '../../../../../shared/ui';
import type { TechnologiesListingData } from './+data';

export default function Page() {
  const { t } = useI18n();
  const { technologies, categories, icons } = useData<TechnologiesListingData>();

  const uncategorised = technologies.filter((tech) => !tech.category_id);
  const groups = categories
    .map((category) => ({
      category,
      items: technologies.filter((tech) => tech.category_id === category.id),
    }))
    .filter((group) => group.items.length > 0);

  return (
    <Section spacing="lg">
      <Container className="flex flex-col gap-10">
        <div className="flex flex-col gap-3">
          {/* A route, not a translated label — see the same choice on the
              services/projects listings. */}
          <Eyebrow>
            <span dir="ltr">/technologies</span>
          </Eyebrow>
          <h1 className="max-w-2xl text-4xl font-bold tracking-tight sm:text-5xl">
            {t('nav.primary.technologies')}
          </h1>
        </div>

        {technologies.length === 0 ? (
          <EmptyState
            title={t('common.technologies.emptyTitle')}
            description={t('common.technologies.emptyDescription')}
          />
        ) : (
          <>
            {groups.map(({ category, items }) => (
              <div key={category.id} className="flex flex-col gap-4">
                <h2 className="text-sm font-semibold tracking-wide text-text-subtle uppercase">
                  {category.name}
                </h2>
                <Grid columns={4}>
                  {items.map((tech) => (
                    <TechnologyCard
                      key={tech.id}
                      technology={tech}
                      icon={tech.icon_media_id ? icons[tech.icon_media_id] : undefined}
                    />
                  ))}
                </Grid>
              </div>
            ))}

            {uncategorised.length > 0 ? (
              <div className="flex flex-col gap-4">
                {groups.length > 0 ? (
                  <h2 className="text-sm font-semibold tracking-wide text-text-subtle uppercase">
                    {t('common.actions.viewAll')}
                  </h2>
                ) : null}
                <Grid columns={4}>
                  {uncategorised.map((tech) => (
                    <TechnologyCard
                      key={tech.id}
                      technology={tech}
                      icon={tech.icon_media_id ? icons[tech.icon_media_id] : undefined}
                    />
                  ))}
                </Grid>
              </div>
            ) : null}
          </>
        )}
      </Container>
    </Section>
  );
}
